import React from "react";
import { useTranslation } from "react-i18next";

// Purely cosmetic: prevents a direct URL visit to a page the current admin
// has no grant for from showing an empty list + a 403 toast on load. The
// backend still enforces the real 403 regardless of what this renders.
const PermissionGuard = ({ allow, children }) => {
  const { t } = useTranslation("errors");

  if (allow) return children;

  return (
    <div className="text-center py-5">
      <i className="fas fa-lock text-muted mb-3" style={{ fontSize: "3rem" }}></i>
      <h5 className="text-muted">{t("permission.denied")}</h5>
    </div>
  );
};

export default PermissionGuard;
